<template>
  <section id="homeLoyaltyCardNumber">
    <div class="container">
      <div class="header">
        <h5>{{stateName}}</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off"> 
        <div class="column">
          <h5>
            Easy as that.
            <br>Welcome to the Shaves family!
          </h5>
          <p>Could you let us know how you would like to collect your card?</p>
        </div>
        
        <div class="columns is-mobile">

          <div class="column is-two-thirds-tablet is-half-desktop  is-one-fifths-widescreen is-one-third-fullhd">
            <div class="content">
              <div class="collectPost">
                <input type="radio" id="collectInStore" v-model="collectpost.type"  value="collect" :checked="collectpost.type == 'collect'">
                <label for="collectInStore"><span>I'd like to </span>collect <span>it </span>in-store </label>

                <input type="radio" v-model="collectpost.type" id="postItToMe" value="post" :checked="collectpost.type == 'post'">
                <!-- <input :checked="collectpost == 'post'" type="radio" v-model="collectpost" id="postItToMe" value="post"> -->
                <label for="postItToMe">Post it to me<span> please</span></label>
              </div>
            </div>
          </div>

        </div>
        <div class="columns control" v-if="collectpost.type == 'collect'">
          <div class="column is-one-third">
            <label for="storeName">Store Name<span>*</span></label>
            <!-- <input v-validate="'required'" v-model="storeName" id="storeName" class="input" type="text"> -->
            <div class="select">
              <select
                name="storeName"
                v-validate="'required'"
                v-model="storeName"
                id="storeName"
                required
              >
                <option value disabled>Select Option</option>
                <option value="Ballito">Ballito</option>
                <option value="Bluff">Bluff</option>
                <option value="Durban">Durban</option>
                <option value="Hillcrest">Hillcrest</option>
                <option value="Pinetown">Pinetown</option>
                <option value="Sandton">Sandton</option>
                <option value="Umhlanga">Umhlanga</option>
              </select>
            </div>
          </div>
          
        </div>
        <div class="columns">
          <div v-if="storeName == 'Ballito'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>Ballito Home Improvement Centre Moffat Drive, Ballito</p>
          </div>
          <div v-if="storeName == 'Bluff'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>142 Archary Road, Bluff Durban South 4052</p>
          </div>
          <div v-if="storeName == 'Durban'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>106 Intersite Avenue Umgeni Business Park, 4091, Durban</p>
          </div>
          <div v-if="storeName == 'Hillcrest'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>45 Old Main Road, Hillcrest, 3610</p>
          </div>
          <div v-if="storeName == 'Pinetown'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>39 Josiah Gumede Road, Pinetown, Durban 3610</p>
          </div>
          <div v-if="storeName == 'Sandton'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>Kramerville West, Commerce Cres, Sandton, Gauteng</p>
          </div>
          <div v-if="storeName == 'Umhlanga'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>Millenium Home Ctr Tetford Circle, Umhlanga, 4320</p>
          </div>
        </div>

        <div class="control" v-if="collectpost.type == 'post'">   
          <div class="columns">
          <div class="column is-one-third">
            
            <label >Would you like you card delivered to a different address than your street address?</label>
            <div class="content">
              <div class="titleContainer yesNo">
                <input type="radio" id="addressOld" v-model="address.type1"  value="yes" :checked="address.type1 == 'yes'">
                <label for="addressOld">Same</label>

                <input type="radio" id="addressNew" v-model="address.type1"  value="no" :checked="address.type1 == 'no'">
                <label for="addressNew">New</label>
              </div>
            </div>
          </div>  
        </div>     
        
          <div class="control" v-if="address.type1 == 'no'">
          <div class="columns">
            <div class="column is-one-third">
              <label for="poBox">Address Or PO Box<span>*</span></label>
              <input v-validate="'required'" v-model="poBox" id="poBox" class="input" type="text">
            </div>

            <div class="column is-one-third">
              <label for="suburbName">Suburb<span>*</span></label>
              <input v-validate="'required'" v-model="suburbName" id="suburbName" class="input" type="text">
            </div>
          </div>
          
          <div class="columns">
           <div class="column is-one-third">
            <label for="province">Province<span>*</span></label>
            <!-- <input v-validate="'required'" v-model="province" id="province" class="input" type="text">
             -->
            <div class="select">
              <select
                name="Province"
                v-validate="'required'"
                v-model="province"
                id="province"
                required
              >
                <option value disabled>Select Option</option>
                <option value="Eastern Cape">Ballito</option>
                <option value="Free-State">Free-State</option>
                <option value="Gauteng">Gauteng</option>
                <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                <option value="Limpopo">Limpopo</option>
                <option value="Mpumalanga">Mpumalanga</option>
                <option value="Northern Cape">Northern Cape</option>
                <option value="North West">North West</option>
                <option value="Western Cape">Western Cape</option>
              </select>
            </div>
          </div>

          <div class="column is-one-third">
            <label for="postalCode">Postal Code<span>*</span></label>
            <input v-validate="'required'" v-model="postalCode" id="postalCode" class="input" type="text">
          </div>
        </div>
      </div>    
        </div>    
  </form>

  <div class="actions">
    <button @click="toContactInfo()" class="button is-blue ml-auto">Done</button>
  </div>
</div>
</section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import axios from "axios";
import { mask } from "vue-the-mask";
// import Autocomplete from 'vuejs-auto-complete';
import alertify from "alertifyjs";

export default {
  name:  "individualloyaltycard",
  directives:  { mask },
  components:  {
    CancelButton,
    // Autocomplete
  },
  data() {
    return {
      stateName: this.$store.state.stateName,
      cardNumber: "",
      salesPerson: "",
      consultants: [],
      collectpost: {
        type:'collect',
        content:null
      },    
      address: {
        type1:'yes',
        content:null
      },
      storeName: '',
      poBox:'',
      suburbName:'',
      province:'',
      postalCode:'',
      storeAddress:'',
      consultantNames:  [
        // {id:  1, name:  'No One'},
        // {id:  2, name:  'John Doe'},
        // {id:  4, name:  'Mary Mo'},
        // {id:  4, name:  'Hennri Slow'}
        {id: 1, name: 'RAJAN  M'},
        {id: 2, name: 'PHILEMON'},
        {id: 3, name: 'SABELO'},
        {id: 4, name: 'JERRY'},
        {id: 5, name: 'LARNALLE'},
        {id: 6, name: 'GOODENOUGH'},
        {id: 7, name: 'ELAINE'},
        {id: 8, name: 'CEDERICK'},
        {id: 9, name: 'PRINCESS'},
        {id: 10, name: 'DONNY'},
        {id: 11, name: 'NELSON'},
        {id: 12, name: 'CARLO'},
        {id: 13, name: 'NOMTHIE'},
        {id: 14, name: 'JAPHET'},
        {id: 15, name: 'JUSTICE Z'},
        {id: 16, name: 'LUNGISANI'},
        {id: 17, name: 'RAJEN N'},
        {id: 18, name: 'THOKAZANI'},
        {id: 19, name: 'ISAAC N'},
        {id: 20, name: 'JABULANI'},
        {id: 21, name: 'ANTOINETTE'},
        {id: 22, name: 'MEGAN'},
        {id: 23, name: 'ASHLEY'},
        {id: 24, name: 'SANJAY'},
        {id: 25, name: 'SUNITHA'},
        {id: 26, name: 'MALIPHATHWE'},
        {id: 27, name: 'MICHAEL G'},
        {id: 28, name: 'MUZI G'},
        {id: 29, name: 'JUNIOR'},
        {id: 30, name: 'ELECTION'},
        {id: 31, name: 'INNOCENT G'},
        {id: 32, name: 'MICHELLE'},
        {id: 33, name: 'LINDA'},
        {id: 34, name: 'MINKY'},
        {id: 35, name: 'TERENCE'},
        {id: 36, name: 'TREVOR'},
        {id: 37, name: 'ANDILE'},
        {id: 38, name: 'LAWRENCE'},
        {id: 39, name: 'NISHA'},
        {id: 40, name: 'THAMIE'},
        {id: 41, name: 'AVINASH'},
        {id: 42, name: 'VERNON'},
        {id: 43, name: 'NJABULO'},
        {id: 44, name: 'DUMISANI'},
        {id: 45, name: 'LUNGANI'},
        {id: 46, name: 'JASON'},
        {id: 47, name: 'ETHEL'},
        {id: 48, name: 'BABE'},
        {id: 49, name: 'MUSA'},
        {id: 50, name: 'SINDI'},
        {id: 51, name: 'APOLLO'},
        {id: 52, name: 'SIYANDA'},
        {id: 53, name: 'THAMI'},
        {id: 54, name: 'MICHAEL'},
        {id: 55, name: 'ASHNI'},
        {id: 56, name: 'MAXWELL'},
        {id: 57, name: 'CLINTON'},
        {id: 58, name: 'THOSH'},
        {id: 59, name: 'XOLANI'},
        {id: 60, name: 'VUSI'},
        {id: 61, name: 'EMMANUEL'},
        {id: 62, name: 'IAN'},
        {id: 63, name: 'SIFISO M'},
        {id: 64, name: 'SIHLE'},
        {id: 65, name: 'PRISCILLA'},
        {id: 66, name: 'XOLANI'},
        {id: 67, name: 'MUZI D'},
        {id: 68, name: 'SIFISO D'},
        {id: 69, name: 'MICHAEL L'},
        {id: 70, name: 'DENZIL'},
        {id: 71, name: 'SHAUN R'},
        {id: 72, name: 'DENVER'},
        {id: 73, name: 'ZWELIHLE'},
        {id: 74, name: 'HOWARD'},
        {id: 75, name: 'MOETI'},
        {id: 76, name: 'JUSTICE R'},
        {id: 77, name: 'ANALIZE'},
        {id: 78, name: 'INNOCENT N'},
        {id: 79, name: 'BRIAN M'},
        {id: 80, name: 'DANNY'},
        {id: 81, name: 'ASHLEY'},
        {id: 82, name: 'KABELO'},
        {id: 83, name: 'PENELOPE'},
        {id: 84, name: 'PAUL'},
        {id: 85, name: 'MDUDUZI'},
        {id: 86, name: 'MYRA'},
        {id: 87, name: 'FRANS'},
        {id: 88, name: 'SHAUN A'},
        {id: 89, name: 'BEAUTY'},
        {id: 90, name: 'PETROS'},
        {id: 91, name: 'BRIAN P'},
        {id: 92, name: 'THOMAS'},
        {id: 93, name: 'NOSISA'},
        {id: 94, name: 'MSOMI'},
        {id: 95, name: 'CRAIG'},
        {id: 96, name: 'ISAAC Z'},
        {id: 97, name: 'GOODNOUGH'},
        {id: 98, name: 'SIBONISIWE'},
        {id: 99, name: 'FEZILE'},
        {id: 100, name: 'BHEKI D'},
        {id: 101, name: 'LINDELANI'},
        {id: 102, name: 'ERICK'},
        {id: 103, name: 'WELLINGTON'}
      ]
    };
  },
  mounted() {
    // axios.get("https://127.0.0.1:8000/api/consultants").then(response => {
    axios.get("https://websiteapi.shaves.co.za/api/consultants").then(response => {
      this.consultants = response.data;
    });

    this.cardNumber = this.$store.state.personal.cardinfo.cardNumber
    this.salesPerson = this.$store.state.personal.cardinfo.salesPerson
    this.storeName = this.$store.state.personal.cardinfo.storeName
    this.poBox = this.$store.state.personal.cardinfo.poBox
    this.suburbName = this.$store.state.personal.cardinfo.suburbName
    this.province = this.$store.state.personal.cardinfo.province
    this.postalCode = this.$store.state.personal.cardinfo.postalCode
    // this.address = this.$store.state.personal.cardinfo.address
  },
  methods:  {
    setConsultant(val){
      this.salesPerson = val.display
    },
    toContactInfo() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
          if(this.salesPerson == ''){
            document.body.classList.add('invalidField')
          }
        } else {
          if (this.storeName) { 
            this.$gtag.event('collect_instore', {
              'event_category': 'engagement',
              'event_label': this.storeName,
              'value': ''
            });
          }
          this.$store.commit("SAVE_PERSONAL_CARD_DETAILS", {
            cardNumber:  this.cardNumber,
            salesPerson:  this.salesPerson,
            storeName: this.storeName,
            poBox: this.poBox,
            suburbName: this.suburbName,
            province: this.province,
            postalCode: this.postalCode,
            address: this.address,
          });
          axios
            .post(
              // "https://127.0.0.1:8000/api/signup/individual",
              "https://websiteapi.shaves.co.za/api/signup/individual",
              this.$store.state.personal
            )
            .then(response => {
              this.$gtag.event('individual_signup_success', {
                'event_category': 'engagement',
                'event_label': 'Customer Successfully Registered',
                'value': ''
              });
              console.log(response);
              this.$router.push("/thankyou");
            })
            .catch(error => {
              this.$gtag.event('individual_signup_failure', {
                'event_category': 'engagement',
                'event_label': 'Error Registering Customer',
                'value': ''
              });
              console.log("ERRROR");
              alertify.error(error.response.data.message);
            });
        }
      });
    }
  },
  created() {
    if (this.$store.state.loyaltyType == "personal") {
      this.stateName = "Home Improver";
    } else {
      this.stateName = "Pension Home Improver";
    }
  },
  watch:  {
    salesPerson:  function(){
      if(this.salesPerson != ''){
        document.body.classList.remove('invalidField')
      }
    }
  }
};
</script>